
export default {
  name: 'Rate',

  props: {
    level: {
      type: Number,
      default: 1
    }
  }
}
